export default "__VITE_ASSET__DZoo6pYP__"